const createPos = async ({ params, api }) => {
  return await api('pos', { body: params.data, method: 'POST' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default createPos;